const addNeededElements = () => {
  const bar = document.querySelector(
    ".plyr__controls__item.plyr__progress__container"
  );
  const timer = document.querySelector(
    ".plyr__controls__item.plyr__time--current.plyr__time"
  );
  const progress = document.querySelector(
    "#custom_controls .progress_wrapper"
  );
  const timerWrapper = document.querySelector(
    "#custom_controls .progress_timer"
  );
  if (progress && bar) progress.appendChild(bar);
  if (timerWrapper && timer) timerWrapper.prepend(timer);
};

export const configurePlyr = (plyr, eventListeners) => {
  addNeededElements();

  eventListeners.forEach(([evt, fn]) => {
    plyr.on(evt, fn);
  });
};

export const moveCaptions = () => {
  const captions = document.querySelector(
    ".plyr__captions"
  );
  if (captions) {
    if (!captions.classList.contains("moveY")) {
      captions.classList.add("moveY");
    }
    return captions;
  }
};
